import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export default function SecretaryReports() {

  return (<>
    <div className="uk-card uk-card-body uk-card-alternative-2 uk-flex uk-flex-middle uk-flex-center uk-card-hover uk-width-1@m uk-margin-small-top">
      <div className="uk-inline uk-transition-toggle" style={{ position: 'relative' }}>
        <button type="button" className="uk-button uk-button-link text-white">
          <div className="uk-transition-scale-up uk-transition-opaque uk-flex uk-flex-middle">
            Relatórios
            <FontAwesomeIcon className="uk-margin-small-left" icon={faPrint} size={"2x"} />
          </div>
        </button>
      </div>
    </div>
    <div uk-dropdown="mode: click; pos: bottom-center;">
      <ul className="uk-nav uk-dropdown-nav">
        <li>
          <Link to={'/secretaria/batismos'}>
            Histórico de Batismo
          </Link>
        </li>
        <li>
          <Link to={'/secretaria/faltas-reuniao'}>
            Ausências por Reunião
          </Link>
        </li>
      </ul>
    </div>
  </>
  )
}